import { 
  PlayArrow as StartedIcon,
  ThumbUp as ApprovalIcon,
  Payment as PayableIcon,
  CreditCard as CreditCardIcon,
  PostAdd as PostableIcon,
  Cancel as RejectedIcon,
  Schedule as PendingIcon
} from '@mui/icons-material';

// Healthcare-professional color scheme with medical industry standards
export const STATUS_CONFIGS = {
  Started: { 
    icon: PendingIcon, 
    color: '#3b82f6',
    bgColor: '#eff6ff',
    displayName: 'Started',
    description: 'New refund requests' 
  },
  InApproval: { 
    icon: ApprovalIcon, 
    color: '#f59e0b',
    bgColor: '#fffbeb',
    displayName: 'In Approval',
    description: 'Pending approval' 
  },
  MyApprovals: { 
    icon: ApprovalIcon, 
    color: '#7c3aed',
    bgColor: '#f3e8ff',
    displayName: 'My Approvals',
    description: 'Assigned to me' 
  },
  Payable: { 
    icon: PayableIcon, 
    color: '#10b981',
    bgColor: '#ecfdf5',
    displayName: 'Payable',
    description: 'Ready for payment' 
  },
  CreditCard: { 
    icon: CreditCardIcon, 
    color: '#8b5cf6',
    bgColor: '#faf5ff',
    displayName: 'Credit Card',
    description: 'CC refunds' 
  },
  Postable: { 
    icon: PostableIcon, 
    color: '#06b6d4',
    bgColor: '#f0fdfa',
    displayName: 'Postable',
    description: 'Ready to post' 
  },
  Rejected: { 
    icon: RejectedIcon, 
    color: '#ef4444',
    bgColor: '#fef2f2',
    displayName: 'Rejected',
    description: 'Denied requests' 
  }
};